import { createContext } from 'react';
var IconContext = /*#__PURE__*/createContext({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: false
});
export { IconContext };